import React, { useState } from 'react'
import DataTable from '../../../../../@Common/DataTable'
import NoRows from '../../../../../@Common/DataTable/NoRows'
import { Box, IconButton, Menu, MenuItem } from '@mui/material'
import { GridMoreVertIcon } from '@mui/x-data-grid'
import moment from 'moment'
import { useOutletContext, useSearchParams } from 'react-router-dom'
import InvoiceDetails from './InvoiceDetails'
import { formatDateWithoutTimezone } from '../../../../../../formatting'
import { getEndOfBillingPeriodView } from '../../../../../../formatting/billingPeriod'
import InvoiceOptionsMenu from './InvoiceOptionsMenu'
import { getFeatureFlags } from '../../../../../../setup/configuration'

const InvoiceOptionMenu = () => {

    const [menuAnchor, setMenuAnchor] = useState(null)

    return (
        <Box>
            <IconButton style={{ paddingTop: '9px' }} onClick={(e) => setMenuAnchor(e.currentTarget)}>
                <GridMoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={() => {
                    setMenuAnchor(null)
                }}
            >
                <MenuItem onClick={() => { }} data-gxid="deleteInvoice">
                    View Invoice
                </MenuItem>
            </Menu>
        </Box>
    )
}

function Invoices() {
    const [searchParams, setSearchParams] = useSearchParams()
    const { EnableNetSuiteInvoices } = getFeatureFlags()
    const { 
        invoices, 
        isLoading, 
        isFetching, 
        invoiceDetails, 
        getDetails, 
        billingTerms, 
        detailsError, 
        onClickSyncInvoice, 
        onClickViewInvoice,
        onClickSetPaymentProfileOverride,
    } = useOutletContext()

    const columns = [
        {
            field: 'id',
            headerName: 'Invoice Id',
            flex: 1
        },
        {
            field: 'currentPeriodStart',
            headerName: 'Invoice Period',
            flex: 2,
            valueGetter: (params) => (`${formatDateWithoutTimezone(params.row.currentPeriodStart)}-${formatDateWithoutTimezone(getEndOfBillingPeriodView(params.row.currentPeriodEnd))}`)

        },
        {
            field: 'amountDue',
            headerName: 'Total',
            valueGetter: (params) => (`$${parseFloat(params.row.amountDue.toFixed(2)).toLocaleString('en')}`),
            flex: 1,
        },
        {
            field: 'dueDate',
            headerName: 'Due Date',
            flex: 1,
            valueGetter: (params) => params.row.dueDate ? new Date(moment(params.row.dueDate).format('MM/DD/YYYY')) : null,
            renderCell: (params) => (`${moment(params.row.dueDate).format('M/DD/YYYY')}`)
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0.7
        },
        {
            field: 'paymentProfileType',
            headerName: 'Payment Method',
            flex: 1.2
        },
        {
            field: 'chargeStatus',
            headerName: 'Charge Status',
            flex: 1
        },
        {
            field: '',
            headerName: '',
            width: 20,
            filterable: false,
            disableColumnMenu: true,
            sortable: false,
            hide: EnableNetSuiteInvoices,
            renderCell: (row) => (
                <InvoiceOptionsMenu
                    row={row.row}
                    onClickSyncInvoice={onClickSyncInvoice}
                    onClickViewInvoice={onClickViewInvoice}
                    onClickSetPaymentProfileOverride={onClickSetPaymentProfileOverride}
                    paymentProfileType={row.row.paymentProfileType}
                />
            ),
        },
    ]

    return (
        searchParams.get('invoiceId') ?
            <InvoiceDetails
                isError={detailsError}
                invoiceId={searchParams.get('invoiceId')}
                billingTerms={billingTerms}
                paymentProfileType={invoices?.find(i => String(i.id) === searchParams.get('invoiceId'))?.paymentProfileType}
                invoiceDetails={invoiceDetails} getDetails={getDetails} /> :
            <DataTable
                noRowsOverlay={<NoRows message={'There are no invoices for this listing.'} />}
                hideFooterWhenNoRows={true}
                hideToolbar={true}
                pagination={true}
                hideFooterSelectedRowCount
                rowSelection
                loading={isLoading || isFetching}
                rowCount={invoices ? invoices.length : 0}
                rows={invoices ? invoices : []}
                pageSizeOptions={[25, 50, 100, 500]}
                columns={columns}
                rowsPerPageOptions={[25, 50, 100, 500]}
                disableRowSelectionOnClick
                onRowClick={(row) => setSearchParams({ invoiceId: row.row.id })}
            />
    )
}

export default Invoices